import { Typography } from '@mui/material';
import React from 'react';

interface IAuditCardListValueProps {
	value: string[];
}

const AuditCardListValue: React.FC<IAuditCardListValueProps> = ({ value }) => (
	<Typography variant="subtitle1" display="inline">
		{value?.join(', ')}
	</Typography>
);

export default AuditCardListValue;
